export enum CompanyWithNotePopUpCellBlock {
  Root = 'CompanyWithNotePopUpCell',
}

export enum CompanyWithNotePopUpCellElement {
  Note = 'note',
}
